export default function ProgressBar({ step, total, stepNames }) {
  return (
    <div className="flex items-center gap-2" aria-label={`Step ${step} of ${total}`}>
      {Array.from({ length: total }, (_, i) => i + 1).map((n) => {
        const done = n < step;
        const active = n === step;
        return (
          <div key={n} className="flex-1 flex flex-col gap-1" aria-current={active ? 'step' : undefined}>
            <div
              className={`h-1 rounded-full transition-colors ${
                done
                  ? 'bg-[#98139C]'
                  : active
                  ? 'bg-[#98139C]/60'
                  : 'bg-[#e3e3e3] dark:bg-white/10'
              }`}
            />
            <span
              className={`text-[10px] uppercase tracking-wide font-medium truncate ${
                active
                  ? 'text-[#98139C] dark:text-[#d87bdb]'
                  : 'text-[#30302F]/60 dark:text-white/50'
              }`}
            >
              {stepNames?.[n - 1] ?? n}
            </span>
          </div>
        );
      })}
    </div>
  );
}
